import React from "react";
import VerticalPage from "@/verticals/VerticalPage";
import { servicesData } from "@/verticals/verticalData";

export default function ServicesPage() {
  return <VerticalPage data={servicesData} />;
}
